
/*
枚举类型
*/

// 接口Code状态
export enum APIResponseCodeType {
    'success' = 1,    // 成功
    'error' = 0,    // 失败
    'redirect' = -1,   // 重定向
    'page' = 2,    // 跳转页面
}

// 页面模式
export enum PageMode {
    'ADD' = 'add',    // 添加
    'EDIT' = 'edit',   // 编辑
}

// 订单管理类型
export enum OrderType {
    'all' = '', //全部
    'wait' = 0, //待支付
    'finish' = 1, //已完成
}

// 短视频状态
export enum ShortVideoStatus {
    'audit_wait',
    'audit_success',
    'audit_fail',
    'putaway',
    'sold_out'
}

// 微信支付平台审核状态
export enum WxPayAuditStatus {
    'wait' = 1,
    'success' = 2,
    'fail' = 3,
}

// 微信支付申请状态
export enum WxPayApplyStatus {
    '未设置',
    '编辑中',
    '审核中',
    '已驳回',
    '待账户验证',
    '待签约',
    '开通权限中',
    '已完成',
    '已作废',
}

export enum SubjectIDIdDocType {
    '中国大陆居民-身份证' = 1,
    '中国香港居民-来往内地通行证',
    '中国澳门居民-来往内地通行证',
    '中国台湾居民-来往大陆通行证',
    '其他国家或地区居民-护照'
}

// 订单管理类型
export enum GoodsOrderType {
    'all_count', //全部
    'pay_count', //待支付
    'delivery_count', //待收货
    'receive_count', //待发货
    'finish_count', //已完成
    'close_count' //已关闭
}

// 结算状态
export enum SettlementType {
    'all_count', //全部
    'wait_count', //待结算
    'end_count', // 已结算
    'refund_count', //已退款
}

// 采购单状态
export enum PurchaseOrderType {
    'all_count' = 0, //全部
    'pay_count', //待支付
    'delivery_count', //待发货
    'receive_count', //待收货
    'finish_count', //已收货/完成
    'close_count' //已关闭
}